(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nasty-g-cart"] && !Shopify.designMode) return;
  try {
    
  /*
   * The only script this page owns. Every stepper and Remove control is a real link to
   * /cart/change, so the cart works with this file absent, blocked or broken. When Horizon's
   * cart-items-component is present it has already handled the click by the time this listener
   * runs, because component.js dispatches on document in the capture phase; all that is left is to
   * stop the browser following the link and throwing away the AJAX update.
   *
   * The guard is the point: if that component never upgraded, updateQuantity is not a function, we
   * do not cancel anything, and the link navigates exactly as it would with scripting off.
   */
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-ng-cart-ajax]') : null;

    if (!target) return;

    const host = target.closest('cart-items-component');

    if (!host || typeof (/** @type {any} */ (host).updateQuantity) !== 'function') return;

    event.preventDefault();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nasty-g-collection"] && !Shopify.designMode) return;
  try {
    
  /*
   * The flavour narrower, and the one piece of JavaScript in this listing.
   *
   * The rest of the page is deliberately script-free -- the panel is a real GET form so that
   * filtering survives a failed script -- and this does not change that. Flavour is not a storefront
   * filter (that list belongs to the Search and discovery app) and Liquid cannot read a querystring,
   * so there is no server round trip to hand this to. Everything it needs is already in the DOM:
   * Liquid stamped each cell with its own flavours. So it stays a progressive enhancement -- the
   * group is hidden until this runs, and a browser that never runs it loses nothing that was ever
   * offered to it.
   *
   * The values are the six flavour families of the WTF guide, not flavour names: Liquid stamped each
   * cell with the families its device carries, read from the one authored taxonomy in
   * snippets/nasty-wtf-family-map.liquid. Compared as `|id|` inside a pipe-wrapped string so a short
   * id cannot match inside a longer one.
   *
   * Ticking two families widens the result, matching how Shopify's own facet groups combine values
   * within one group.
   */
  (function () {
    var SEL = '.nasty-g-collection';

    function wire(root) {
      var boxes = root.querySelectorAll('[data-ng-flavour]');
      if (!boxes.length) return;

      var group = root.querySelector('[data-ng-flavour-group]');
      var badge = root.querySelector('[data-ng-flavour-count]');
      var field = root.querySelector('[data-ng-flavour-field]');
      var count = root.querySelector('[data-ng-count]');
      var empty = root.querySelector('[data-ng-flavour-empty]');
      var cells = root.querySelectorAll('.nasty-g-collection__cell');
      var total = count ? count.textContent.trim() : '';

      function apply() {
        var picked = [];
        for (var i = 0; i < boxes.length; i++) {
          if (boxes[i].checked) picked.push(boxes[i].value);
        }

        var shown = 0;
        for (var c = 0; c < cells.length; c++) {
          var carries = cells[c].getAttribute('data-ng-families') || '';
          var match = !picked.length;
          for (var p = 0; p < picked.length && !match; p++) {
            if (carries.indexOf('|' + picked[p] + '|') !== -1) match = true;
          }
          cells[c].hidden = !match;
          if (match) shown++;
        }

        if (badge) {
          badge.textContent = picked.length ? String(picked.length) : '';
          badge.hidden = !picked.length;
        }

        if (count) {
          count.textContent = picked.length
            ? shown + (shown === 1 ? ' product' : ' products')
            : total;
        }

        if (empty) empty.hidden = shown !== 0;
        if (field) field.value = picked.join('|');

        /*
         * The selection goes in the address bar so a filtered view can be shared or reloaded, and
         * replaceState rather than pushState because ticking a box is refining one view, not
         * visiting a new page -- Back should leave the listing, not walk every tick.
         */
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          if (picked.length) {
            url.searchParams.set('flavour', picked.join('|'));
          } else {
            url.searchParams.delete('flavour');
          }
          window.history.replaceState({}, '', url.toString());
        }
      }

      /* An Apply submit drops unnamed controls, so the selection arrives back as ?flavour=. */
      var initial = new URL(window.location.href).searchParams.get('flavour');
      if (!initial && field && field.value) initial = field.value;

      if (initial) {
        var wanted = initial.split('|');
        for (var b = 0; b < boxes.length; b++) {
          if (wanted.indexOf(boxes[b].value) !== -1) boxes[b].checked = true;
        }
      }

      for (var w = 0; w < boxes.length; w++) {
        boxes[w].addEventListener('change', apply);
      }

      if (group) group.hidden = false;
      apply();
    }

    function boot() {
      var roots = document.querySelectorAll(SEL);
      for (var r = 0; r < roots.length; r++) wire(roots[r]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    /* The theme editor re-renders a section without reloading the page. */
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector(SEL);
      if (root) wire(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nasty-g-featuring"] && !Shopify.designMode) return;
  try {
    
  /*
   * Scroll bound parallax for the product record panel's photograph.
   *
   * Travel is read from --nz-panel-bleed rather than hard coded, so the 100px desktop figure and the
   * 48px phone figure live in one place, in the stylesheet, next to the geometry they belong to.
   *
   * The listener is on document in the capture phase, not on window. Horizon scrolls `.page-wrapper`
   * at desktop widths and the document element at phone widths; scroll events do not bubble, so a
   * window listener misses the desktop case entirely, while a capture listener on document sees both
   * because the capture phase still runs down the ancestor chain for non-bubbling events.
   */
  class NzPanelParallax extends HTMLElement {
    connectedCallback() {
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = 0;

      this.onScroll = () => {
        if (this.frame) return;

        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };

      this.onPreference = () => {
        if (this.reduced.matches) {
          this.detach();
          this.shift = '';
          this.style.removeProperty('--nz-panel-shift');
        } else {
          this.attach();
        }
      };

      this.reduced.addEventListener('change', this.onPreference);

      if (!this.reduced.matches) this.attach();
    }

    disconnectedCallback() {
      this.detach();
      this.reduced.removeEventListener('change', this.onPreference);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    attach() {
      if (this.attached) return;

      this.attached = true;
      document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.update();
    }

    detach() {
      if (!this.attached) return;

      this.attached = false;
      document.removeEventListener('scroll', this.onScroll, { capture: true });
      window.removeEventListener('resize', this.onScroll);
    }

    update() {
      const box = this.getBoundingClientRect();
      const view = window.innerHeight;
      const travel = parseFloat(getComputedStyle(this).getPropertyValue('--nz-panel-bleed'));

      if (!travel) return;

      /*
       * 0 when the top edge touches the bottom of the viewport, 1 when the bottom edge leaves the
       * top of it. Half a bleed either side of centre, so total travel is one bleed and the frame is
       * centred on its own art at the moment the section is centred in the viewport.
       *
       * Deliberately not skipped while off screen. Clamping instead of returning is what guarantees
       * the photograph is already sitting on its end stop the moment the frame appears; an early
       * return leaves whatever value the last visible frame had, and the section enters the viewport
       * and then slides, which reads as a glitch rather than as parallax.
       */
      const span = view + box.height;
      const progress = Math.min(1, Math.max(0, (view - box.top) / span));
      const shift = `${((progress - 0.5) * travel).toFixed(2)}px`;

      if (shift === this.shift) return;

      this.shift = shift;
      this.style.setProperty('--nz-panel-shift', shift);
    }
  }

  if (!customElements.get('nz-panel-parallax')) {
    customElements.define('nz-panel-parallax', NzPanelParallax);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nasty-locator-index"] && !Shopify.designMode) return;
  try {
    
  /*
   * Keeps the view on the group you just opened.
   *
   * Everything else about this section works with scripting off: the groups are native `<details>`
   * sharing a `name`, so they open, close and stay exclusive on their own. This only decides where
   * the page is looking afterwards, and it has one job, which is to make that a non event. Opening
   * a group collapses another one, often above this one and often a thousand pixels tall, and the
   * page has no reason of its own to keep your place through that.
   */
  (function () {
    var SECTION = '.nasty-locator-index';

    function stickyHeight(root) {
      /*
       * The locator's filter bar is sticky from 1000px and sits directly under the header, so an
       * opened card has to clear both. It belongs to the sibling section, not to this one, and it
       * is only sticky at some widths, so it is measured rather than assumed.
       */
      var bar = document.querySelector('.nasty-locator__controls');
      if (!bar) return 0;
      if (getComputedStyle(bar).position !== 'sticky') return 0;
      return Math.round(bar.getBoundingClientRect().height);
    }

    /*
     * The element that actually scrolls. This page is not scrolled by the window: the theme puts
     * the whole document inside `.page-wrapper` and scrolls that, so `window.scrollBy` moves
     * nothing here. Rather than hard code that, the nearest scrollable ancestor is found, and
     * `nudge` below proves it moves before trusting it.
     */
    function findScroller(el) {
      var node = el.parentElement;

      while (node && node !== document.documentElement) {
        var overflow = getComputedStyle(node).overflowY;
        if (
          (overflow === 'auto' || overflow === 'scroll') &&
          node.scrollHeight > node.clientHeight + 1
        ) {
          return node;
        }
        node = node.parentElement;
      }

      return document.scrollingElement || document.documentElement;
    }

    /*
     * Moves the view by `delta` immediately and reports how far it really went.
     *
     * `scroll-behavior: smooth` anywhere up the tree would turn each of these into an animation,
     * and a pin that animates is the very stutter this is here to remove, so it is forced off for
     * the write and put back after. If the container refuses the write the window is tried, and a
     * caller that gets 0 back knows the pin is not available rather than assuming it worked.
     */
    function nudge(scroller, delta) {
      if (Math.abs(delta) < 0.5) return 0;

      var before = scroller.scrollTop;
      var previous = scroller.style.scrollBehavior;

      scroller.style.scrollBehavior = 'auto';
      scroller.scrollTop = before + delta;
      var moved = scroller.scrollTop - before;
      scroller.style.scrollBehavior = previous;

      if (Math.abs(moved) < 0.5) {
        var windowBefore = window.scrollY;
        window.scrollBy(0, delta);
        moved = window.scrollY - windowBefore;
      }

      return moved;
    }

    function wire(root) {
      var groups = root.querySelectorAll('.nasty-locator__group');
      if (!groups.length) return;

      function sync() {
        root.style.setProperty('--ng-locator-sticky', stickyHeight(root) + 'px');
      }

      sync();
      window.addEventListener('resize', sync);

      /*
       * `toggle` does not bubble, so the listener is registered in the capture phase on the
       * section rather than once per group. It fires on close as well, hence the `open` test.
       */
      root.addEventListener(
        'toggle',
        function (event) {
          var group = event.target;
          if (!group.open || !group.classList.contains('nasty-locator__group')) return;

          sync();

          var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var scroller = findScroller(group);
          var box = root.querySelector('.nasty-locator-index__groups') || root;

          /*
           * Where this row should stay. `scroll-margin-top` already carries the header and the
           * filter bar, so it is read back here rather than recomputed: one offset, declared once,
           * in the stylesheet next to the layout that causes it.
           *
           * The row keeps the screen position it was clicked at, unless that position is under the
           * sticky bars, in which case it comes down to clear them. It is deliberately not moved to
           * the top of the screen: the row is already under the reader's pointer, and moving it
           * anyway is motion they did not ask for.
           */
          var offset = parseFloat(getComputedStyle(group).scrollMarginTop) || 0;
          var target = Math.max(group.getBoundingClientRect().top, offset);

          var lastHeight = -1;
          var stableFrames = 0;
          var startedAt = Date.now();
          var pinned = true;

          /*
           * The pin, and the reason this is a loop rather than one deferred measurement.
           *
           * Opening a group closes whichever was open, over 260ms of animated height. Everything
           * below that collapse, this row included, travels up the page while it runs. Measuring
           * once and correcting afterwards is what produced the glitch: the row drifted for a
           * quarter of a second and was then yanked back, read as a scroll down followed by a
           * scroll up.
           *
           * Holding it still every frame means there is nothing to yank back. The collapse happens
           * around the row instead of carrying it, which is the whole of "stay at the open tab".
           */
          var hold = function () {
            var height = box.getBoundingClientRect().height;

            if (pinned) {
              var drift = group.getBoundingClientRect().top - target;
              if (nudge(scroller, drift) === 0 && Math.abs(drift) > 0.5) {
                /*
                 * Nothing moved, so this view cannot be pinned. Stop fighting it and let the
                 * settled scroll below do the work, which is the behaviour before the pin existed.
                 */
                pinned = false;
              }
            }

            if (Math.abs(height - lastHeight) < 0.5) {
              stableFrames += 1;
            } else {
              stableFrames = 0;
            }

            lastHeight = height;

            if (stableFrames < 2 && Date.now() - startedAt < 600) {
              requestAnimationFrame(hold);
              return;
            }

            /*
             * The layout has settled. If the row was pinned it is already exactly where it should
             * be and `nearest` is a no-op, which is the intended outcome. It still runs because an
             * opened card can now extend past the bottom of the screen, and because an unpinnable
             * view needs this to be the correction it always was.
             *
             * `nearest`, not `start`: both top-align a card taller than the screen, since that is
             * the only way to show one, but on a short card `start` demanded a scroll the page
             * could only answer by going to its end. That is how opening PTA North, the last and
             * smallest group, used to land the reader in the footer.
             */
            group.scrollIntoView({
              block: 'nearest',
              behavior: reduced ? 'auto' : 'smooth'
            });
          };

          requestAnimationFrame(hold);
        },
        true
      );
    }

    function boot() {
      var roots = document.querySelectorAll(SECTION);
      for (var i = 0; i < roots.length; i++) wire(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector(SECTION);
      if (root) wire(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
